import { GeocodingResult } from "../dtos/GeocodingResult";
import { isValidCoordinates } from "./isValidCoordinates";

export const geocodeAddress = async (address: string): Promise<GeocodingResult | null> => {
  if (!address?.trim()) return null;
  try {
    const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1`, {
      headers: { "Accept-Language": "vi-VN,vi;q=0.9" },
    });
    if (!res.ok) return null;
    const data = await res.json();
    if (!Array.isArray(data) || data.length === 0) return null;
    const lat = parseFloat(data[0].lat);
    const lng = parseFloat(data[0].lon);
    if (!isValidCoordinates(lat, lng)) return null;
    return { lat, lng, displayName: data[0].display_name };
  } catch (err) {
    console.error("Geocoding error:", err);
    return null;
  }
};
